import React from 'react';
import { PieChart } from 'react-minimal-pie-chart';
import { Chart } from 'react-charts';
import { useQuery } from '@tanstack/react-query';
import StatusChart from './statusChart';
import Loader from '../shared/loader/loader';

const PieAndBarChart = ({ orderRecord1, barRecord1 }) => {


    // Placeholder data for shipments
    const shipmentsData = {
        onTime: 80, // 80% on-time shipments
        outOfTime: 20, // 20% out-of-time shipments
    };
    const totalShipments = shipmentsData.onTime + shipmentsData.outOfTime;
    const onTimeValue = (shipmentsData.onTime / totalShipments) * 100;
    const outOfTimeValue = (shipmentsData.outOfTime / totalShipments) * 100;

    // Handle undefined orderRecode
    const ordersData = orderRecord1 || [];

if (!barRecord1) {
  return <Loader />;
}

// If empty, force a safe fallback dataset
const hasData = Array.isArray(barRecord1) && barRecord1.length > 0;

const chartData = hasData
  ? [
      {
        label: "Orders",
        data: barRecord1.map(item => ({
          week: item.week,
          orders: item.orders
        }))
      }
    ]
  : [
      {
        label: "Orders",
        data: [{ week: "No Data", orders: 0 }]
      }
    ];
    // Primary axis configuration
    const primaryAxis = {
        getValue: datum => datum.week,
        type: 'ordinal'
    };

    // Secondary axes configuration
    const secondaryAxes = [
        {
            getValue: datum => datum.orders,
            type: 'linear',
            elementType: 'bar',
        }
    ];

    // Custom series style
    const getSeriesStyle = series => {
        return {
            fill: 'url(#gradient-fill)', // Use the gradient ID for fill
            stroke: 'url(#gradient-stroke)', // Use the gradient ID for stroke
            strokeWidth: 4,
            strokeLinejoin: 'round'
        };
    };

    return (
        <>
            <div className='grid lg:grid-cols-5 grid-cols-1 mt-6 gap-5 bg-[#eaeff6]'>
                <div className='col-span-3 bg-[#fff] p-6 rounded-[10px]' style={{ border: "1px solid rgba(5, 63, 146, 0.24)" }}>
                    <h1 className='text-[#000] text-[18px] font-medium'>Amount of orders by Week</h1>
                    <div className='lg:h-[90%] h-[400px] flex justify-center w-full mt-2'>
                        <svg width="0" height="0">
                            <defs>
                                <linearGradient id="gradient-fill" x1="0%" y1="0%" x2="0%" y2="100%">
                                    <stop offset="0%" style={{ stopColor: '#DA1C00' }} />
                                    <stop offset="100%" style={{ stopColor: '#EB8079' }} />
                                </linearGradient>
                                <linearGradient id="gradient-stroke" x1="0%" y1="0%" x2="0%" y2="100%">
                                    <stop offset="0%" style={{ stopColor: '#DA1C00' }} />
                                    <stop offset="100%" style={{ stopColor: '#EB8079' }} />
                                </linearGradient>
                            </defs>
                        </svg>
                        <Chart style={{ width: "100%", height: "100%" }} options={{ data: chartData, primaryAxis, secondaryAxes, getSeriesStyle }} />
                    </div>
                </div>

                <div className='bg-[#fff] lg:col-span-2 col-span-3 p-2 rounded-[10px] flex flex-col h-full' style={{ border: "1px solid rgba(5, 63, 146, 0.24)" }}>
                    <div className='flex-1 flex justify-center items-center w-full h-full'>
                        <div className='w-full h-full'>
                            <StatusChart orderRecode={orderRecord1} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PieAndBarChart;